function logEvent(event, elapsed, el) {
    if (elapsed == null) return false;
    axios
        .post("log_event?tid=" + getTid(), { event: event, elapsed: elapsed })
        .then(response => {
            stopTimer(el);
        })
        .catch(error => {
            if (error.response && error.response.status == 401) {
                window.location.reload(true);
            }
        });
}

function startTimer(el) {
    if (el.getAttribute('disabled') == 'disabled' || el.disabled || el.hasAttribute('timer')) {
        return false;
    }
    el.setAttribute('timer', Date.now());
}

function stopTimer(el) {
    el.removeAttribute('timer');
}

function getElapsed(el) {
    if (!el.hasAttribute('timer')) {
        return null;
    }
    return (Date.now() - el.getAttribute('timer')) / 1000;
}

function getTid() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    return params.get("tid");
}

export const analyticsDirective = {
    bind: function(el, binding) {
        if (el.tagName === 'INPUT') {
            el.addEventListener('focus', function() {
                startTimer(el);
            })

            el.addEventListener('blur', function() {
                var elapsed = getElapsed(el);
                logEvent(binding.value, elapsed, el);
            })
        } else {
            el.addEventListener('mouseenter', function() {
                startTimer(el)
            });

            ['mouseleave', 'click'].forEach(function(event) {

            })
            el.addEventListener('mouseleave', function(event) {
                var elapsed = getElapsed(el);
                logEvent(binding.value, elapsed, el);
            })

            if (!el.hasAttribute('modalTrigger')) {
                el.addEventListener('click', function(event) {
                    var elapsed = getElapsed(el);
                    logEvent(binding.value, elapsed, el);
                })
            }
        }

    },

}